import { Skeleton } from 'antd';

import { ColumnWrapper, ItemWrapper, Wrapper } from './ModeSkeleton.styles';

const ITEM_SIZE = 40;

export const ModeSkeleton = () => {
  return (
    <Wrapper>
      {Array.from({ length: 4 }).map((_, index) => (
        <ItemWrapper key={index}>
          <Skeleton.Avatar shape="square" size={ITEM_SIZE} active />
          <ColumnWrapper>
            <Skeleton.Input active />
            <Skeleton.Input block active size="small" />
          </ColumnWrapper>
        </ItemWrapper>
      ))}
    </Wrapper>
  );
};
